<div class="app-shell">
  <app-cabecalho-marca
    [logo]="logo"
    [iniciais]="iniciais"
    [nome]="nome"
    [agora]="agora">
  </app-cabecalho-marca>

  <main class="container py-4">
    <app-navegacao-servidor
      [aba]="aba"
      [itens]="itens"
      (selecionar)="selecionar.emit($event)"
      (sair)="sair.emit()">
    </app-navegacao-servidor>

    <app-alerta-mensagem [mensagem]="mensagem"></app-alerta-mensagem>
    <ng-content></ng-content>
  </main>
</div>
